import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { tokenInterceptor } from "../../api/authHeaders";
import { backendURL, config, Backend_Urls } from "../../api/endpoints";

const getUserClients = createAsyncThunk(
  "portalManagement/getUserClients",
  async ({}: {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.account_management}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getClientPrograms = createAsyncThunk(
  "portalManagement/getClientPrograms",
  async ({ client_index }: { client_index: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.client_programs}/${client_index}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getClientSalesRep = createAsyncThunk(
  "portalManagement/getClientSalesRep",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.client_salesmen}/${customer_id}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getTrainingUsers = createAsyncThunk(
  "portalManagement/getTrainingUsers",
  async ({} : {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.training_users}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getTrainingRoles = createAsyncThunk(
  "portalManagement/getTrainingRoles",
  async ({}: {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.training_roles}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getTrainingSchools = createAsyncThunk(
  "portalManagement/getTrainingSchools",
  async ({}: {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.training_schools}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getTrainingDomains = createAsyncThunk(
  "portalManagement/getTrainingDomains",
  async ({}: {}, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.training_domains}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getTableSettings = createAsyncThunk(
  "portalManagement/getTableSettings",
  async ({ program_index, target_table }: { program_index: number; target_table: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.user_table_settings}/${program_index}/${target_table}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const saveTableSettings = createAsyncThunk(
  "portalManagement/saveTableSettings",
  async ({ program_index, target_table, settings }: { program_index: number; target_table: string; settings: any }, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(
        `${backendURL}${Backend_Urls.user_table_settings}/${program_index}/${target_table}`,
        { settings },
        tokenInterceptor()
      );

      return { ...data, program_index, target_table, settings };
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const deleteTableSettings = createAsyncThunk(
  "portalManagement/deleteTableSettings",
  async ({ program_index, target_table }: { program_index: number; target_table: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(
        `${backendURL}${Backend_Urls.user_table_settings}/${program_index}/${target_table}`,
        tokenInterceptor()
      );

      return { ...data, program_index, target_table };
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getBranchesDepartments = createAsyncThunk(
  "portalManagement/getBranchesDepartments",
  async ({ payload }: { payload: any }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.branches_and_departments}/${payload.customer_id}`,
        payload,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getLastUpdated = createAsyncThunk(
  "portalManagement/getLastUpdated",
  async ({ payload }: { payload: any }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.last_updated}/${payload}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getGrowthScore = createAsyncThunk(
  "portalManagement/getGrowthScore",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.growth_score}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getRetention = createAsyncThunk(
  "portalManagement/getRetention",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.retention}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getAtRisk = createAsyncThunk(
  "portalManagement/getAtRisk",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.atrisk}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getGoogleReviews = createAsyncThunk(
  "portalManagement/getGoogleReviews",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.g_reviews}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getNpsScore = createAsyncThunk(
  "portalManagement/getNpsScore",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.nps_score}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getNpsSurvey = createAsyncThunk(
  "portalManagement/getNpsSurvey",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.nps_survey}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getIndustries = createAsyncThunk(
  "portalManagement/getIndustries",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.industries}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getPurchase = createAsyncThunk(
  "portalManagement/getPurchase",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.purchase}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getRetentionLeads = createAsyncThunk(
  "portalManagement/getRetentionLeads",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.retention_leads}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getProspectVerified = createAsyncThunk(
  "portalManagement/getProspectVerified",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.prospect_verified}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getEmailReports = createAsyncThunk(
  "portalManagement/getEmailReports",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.get_email_reports}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getGrowthRate = createAsyncThunk(
  "portalManagement/getGrowthRate",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.growth_rate}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getGrowthRateDetail = createAsyncThunk(
  "portalManagement/getGrowthRateDetail",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.growth_rate_detail}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getGrowthRateBenchmark = createAsyncThunk(
  "portalManagement/getGrowthRateBenchmark",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.growth_rate_benchmark}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getForecastDetail = createAsyncThunk(
  "portalManagement/getForecastDetail",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.forecast_detail}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getAtriskDetail = createAsyncThunk(
  "portalManagement/getAtriskDetail",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.atrisk_detail}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getWgs = createAsyncThunk(
  "portalManagement/wgs",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.wgs}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getWgsDetail = createAsyncThunk(
  "portalManagement/getWgsDetail",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.wgs_detail}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getGgdRating = createAsyncThunk(
  "portalManagement/getGgdRating",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.ggd_rating}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getGgdRatingDetail = createAsyncThunk(
  "portalManagement/getGgdRatingDetail",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.ggd_rating_detail}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getNetPromoter = createAsyncThunk(
  "portalManagement/getNetPromoter",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.net_promoter}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getCustomerSurvey = createAsyncThunk(
  "portalManagement/getCustomerSurvey",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.customer_survey}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getRetentionRate = createAsyncThunk(
  "portalManagement/getRetentionRate",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.retention_rate}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getLastPurchaseCustomerLeads = createAsyncThunk(
  "portalManagement/getLastPurchaseCustomerLeads",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.last_purchase_cust_leads}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getLastPurchaseDetail = createAsyncThunk(
  "portalManagement/getLastPurchaseDetail",
  async (
    { customer_id }: { customer_id: string },
    { getState, rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.last_purchase_detail}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      const selected = (getState() as any).portalManagement?.selectedClient
        ?.customer_id;
      if (
        selected != null &&
        String(selected) !== String(customer_id)
      ) {
        return rejectWithValue({ stale: true });
      }

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getProspectLeadsReports = createAsyncThunk(
  "portalManagement/getProspectLeadsReports",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.prospect_leads_reports}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getProspectLeadsReportsDetail = createAsyncThunk(
  "portalManagement/getProspectLeadsReportsDetail",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.prospect_leads_reports_detail}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getGainLostAccounts = createAsyncThunk(
  "portalManagement/getGainLostAccounts",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.gain_and_lost_accounts}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getIndustryByRevenue = createAsyncThunk(
  "portalManagement/getIndustryByRevenue",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.industry_by_revenue}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getIndustryByRevenueDetail = createAsyncThunk(
  "portalManagement/getIndustryByRevenueDetail",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.industry_by_revenue_detail}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getPurchaseDistribution = createAsyncThunk(
  "portalManagement/getPurchaseDistribution",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.purchase_distribution}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getDistributionTransactionRevenue = createAsyncThunk(
  "portalManagement/getDistributionTransactionRevenue",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.distribution_transaction_revenue}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getCustomerSurveyDetail = createAsyncThunk(
  "portalManagement/getCustomerSurveyDetail",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.customer_survey_detail}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getProductAnalysisDetail = createAsyncThunk(
  "portalManagement/getProductAnalysisDetail",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.product_analysis_detail}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getRankByEmail = createAsyncThunk(
  "portalManagement/getRankByEmail",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.rank_by_email}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getRankByRetention = createAsyncThunk(
  "portalManagement/getRankByRetention",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.rank_by_retention}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getRankByStableAccount = createAsyncThunk(
  "portalManagement/getRankByStableAccount",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.rank_by_stable_account}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getRankByWgs = createAsyncThunk(
  "portalManagement/getRankByWgs",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.rank_by_wgs}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getRankByWgsDetails = createAsyncThunk(
  "portalManagement/getRankByWgsDetails",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.rank_by_wgs_detail}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getMarketByCustomer = createAsyncThunk(
  "portalManagement/getMarketByCustomer",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.market_by_customer}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getMarketOverview = createAsyncThunk(
  "portalManagement/getMarketOverview",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.market_overview}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getProductByCustomerCount = createAsyncThunk(
  "portalManagement/getProductByCustomerCount",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.product_by_cust_count}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getProductByRevenue = createAsyncThunk(
  "portalManagement/getProductByRevenue",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.product_by_revenue}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getForecastRevenuePlan = createAsyncThunk(
  "portalManagement/getForecastRevenuePlan",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.forecast_revenue_plan}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getBranchTransaction = createAsyncThunk(
  "portalManagement/getBranchTransaction",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.branch_transactions}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getTrainingCourse = createAsyncThunk(
  "portalManagement/getTrainingCourse",
  async ({ 
    customer_id,
    account_type,
    people_user_id
  }: { 
    customer_id: string,
    account_type: string,
    people_user_id: string 
  }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.employee_course}/${customer_id}`,
        { 
          client_id: customer_id,
          account_type: account_type,
          people_user_id: people_user_id
        },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getTrainingModule = createAsyncThunk(
  "portalManagement/getTrainingModule",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.employee_module}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getTrainingModuleSummary = createAsyncThunk(
  "portalManagement/getTrainingModuleSummary",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.employee_module_summary}/${customer_id}`,
        { client_id: customer_id },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getClientSalesmenMetrics = createAsyncThunk(
  "portalManagement/getClientSalesmenMetrics",
  async (
    { customer_id, salesrep }: { customer_id: string; salesrep: string },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.client_salesmen_data}/${customer_id}`,
        { client_id: customer_id, salesrep: salesrep },
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getBranchRankByStable = createAsyncThunk(
  "portalManagement/getBranchRankByStable",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.get_branch_rank_by_stable}/${customer_id}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getBranchRankByEmail = createAsyncThunk(
  "portalManagement/getBranchRankByEmail",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.get_branch_rank_by_email}/${customer_id}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getBranchRankByRetention = createAsyncThunk(
  "portalManagement/getBranchRankByRetention",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.get_branch_rank_by_retention}/${customer_id}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const getAssociatedProduct = createAsyncThunk(
  "portalManagement/getAssociatedProduct",
  async ({ customer_id }: { customer_id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${backendURL}${Backend_Urls.associated_product}/${customer_id}`,
        tokenInterceptor()
      );

      return data;
    } catch (error: any) {
      if (error.response && error.response.data.msg) {
        return rejectWithValue(error.response);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

// ── Dashboard aggregate ─────────────────────────────────────────────────────
// One POST per portal tab instead of ~35 standalone round-trips. Each response
// section is byte-identical to its standalone endpoint, so this thunk fans
// every section through the standalone thunk's own pending/fulfilled/rejected
// actions — the slice reducers are untouched and every loading flag and
// payload shape behaves exactly as before. Sections without a mapped thunk
// here (last_updated, branches_and_departments — different arg shapes, still
// dispatched standalone by their owners) are simply ignored.

const AGGREGATE_SECTION_THUNKS: Record<string, any> = {
  growth_score: getGrowthScore,
  nps_score: getNpsScore,
  retention_leads: getRetentionLeads,
  get_email_reports: getEmailReports,
  last_purchase_cust_leads: getLastPurchaseCustomerLeads,
  last_purchase_detail: getLastPurchaseDetail,
  growth_rate: getGrowthRate,
  growth_rate_detail: getGrowthRateDetail,
  growth_rate_benchmark: getGrowthRateBenchmark,
  forecast_detail: getForecastDetail,
  net_promoter: getNetPromoter,
  customer_survey: getCustomerSurvey,
  customer_survey_detail: getCustomerSurveyDetail,
  retention_rate: getRetentionRate,
  atrisk_detail: getAtriskDetail,
  branch_transactions: getBranchTransaction,
  industry_by_revenue_detail: getIndustryByRevenueDetail,
  purchase_distribution: getPurchaseDistribution,
  distribution_transaction_revenue: getDistributionTransactionRevenue,
  product_analysis_detail: getProductAnalysisDetail,
  rank_by_email: getRankByEmail,
  rank_by_retention: getRankByRetention,
  rank_by_stable_account: getRankByStableAccount,
  get_branch_rank_by_email: getBranchRankByEmail,
  get_branch_rank_by_retention: getBranchRankByRetention,
  get_branch_rank_by_stable: getBranchRankByStable,
  market_by_customer: getMarketByCustomer,
  market_overview: getMarketOverview,
  product_by_cust_count: getProductByCustomerCount,
  product_by_revenue: getProductByRevenue,
  prospect_leads_reports: getProspectLeadsReports,
  prospect_leads_reports_detail: getProspectLeadsReportsDetail,
  gain_and_lost_accounts: getGainLostAccounts,
  associated_product: getAssociatedProduct,
  forecast_revenue_plan: getForecastRevenuePlan,
};

// Per-tab section WAVES, partitioned by measured cost (2026-08-10, dev,
// client 332): the fast wave paints in <1s while the whales (>1s each:
// retention_leads 2.9s, last_purchase_cust_leads 2.3s, product_analysis_detail
// 1.7s, product_by_* 1.2s) arrive in their own concurrent call. The lists are
// derived from what each SCREEN's selectors actually read (fields like
// revinvData and wsr12RawData merge payloads from several thunks — the
// backend's TABS lists missed retention_rate/net_promoter/customer_survey on
// landing, which left the RETENTION and NPS tiles empty), unioned with the
// backend's TABS. last_updated and branches_and_departments are fetched by
// their owners; last_purchase_detail is download-only and fetched on demand
// (salesMarketing.tsx).
export const AGGREGATE_WAVES: Record<string, string[][]> = {
  // growth_score is deliberately absent: its fulfilled reducer's only data
  // write is state.salesReps (a legacy copy-paste), so fetching it on landing
  // clobbered the rep list with a growth-score payload. No landing card reads it.
  landing: [
    [
      "nps_score",
      "growth_rate",
      "growth_rate_benchmark",
      "forecast_detail",
      "atrisk_detail",
      "get_email_reports",
      "market_by_customer",
      "purchase_distribution",
      "retention_rate",
      "net_promoter",
      "customer_survey",
      "gain_and_lost_accounts",
    ],
    ["retention_leads", "last_purchase_cust_leads"],
  ],
  growth_forecast: [
    [
      "growth_rate",
      "growth_rate_detail",
      "growth_rate_benchmark",
      "forecast_detail",
      "forecast_revenue_plan",
      "atrisk_detail",
      "get_email_reports",
      "net_promoter",
      "customer_survey",
      "customer_survey_detail",
      "retention_rate",
      "nps_score",
      "gain_and_lost_accounts",
    ],
  ],
  sales_marketing: [
    [
      "growth_rate",
      "forecast_detail",
      "retention_rate",
      "market_by_customer",
      "market_overview",
      "associated_product",
      "prospect_leads_reports",
      "prospect_leads_reports_detail",
      "gain_and_lost_accounts",
      "rank_by_email",
      "rank_by_retention",
      "rank_by_stable_account",
      "get_branch_rank_by_email",
      "get_branch_rank_by_retention",
      "get_branch_rank_by_stable",
    ],
    [
      "retention_leads",
      "last_purchase_cust_leads",
      "product_analysis_detail",
      "product_by_cust_count",
      "product_by_revenue",
    ],
  ],
  transactions: [
    [
      "growth_rate",
      "forecast_detail",
      "forecast_revenue_plan",
      "branch_transactions",
      "industry_by_revenue_detail",
      "purchase_distribution",
      "distribution_transaction_revenue",
      "gain_and_lost_accounts",
      "retention_rate",
    ],
  ],
};

const getDashboardAggregate = createAsyncThunk(
  "portalManagement/getDashboardAggregate",
  async (
    { customer_id, keys }: { customer_id: any; keys: string[] },
    { dispatch, getState, requestId }
  ) => {
    const sections = keys.filter((key) => AGGREGATE_SECTION_THUNKS[key]);
    const arg = { customer_id };
    const rid = `aggregate-${requestId}`;
    const isStaleClient = () => {
      const selected = (getState() as any).portalManagement?.selectedClient
        ?.customer_id;
      return (
        selected != null && String(selected) !== String(customer_id)
      );
    };
    sections.forEach((key) =>
      dispatch(AGGREGATE_SECTION_THUNKS[key].pending(rid, arg))
    );
    try {
      const { data } = await axios.post(
        `${backendURL}${Backend_Urls.dashboard_aggregate}/${customer_id}`,
        { keys: sections },
        tokenInterceptor()
      );
      if (isStaleClient()) {
        sections.forEach((key) =>
          dispatch(
            AGGREGATE_SECTION_THUNKS[key].rejected(
              new Error("stale client"),
              rid,
              arg
            )
          )
        );
        return { keys: sections, sections: 0, stale: true };
      }
      sections.forEach((key) => {
        const section = data?.data?.[key];
        if (section === null || section === undefined) {
          // The aggregate degraded this section (data[key] = null + errors
          // entry) — same terminal state as the standalone call failing.
          dispatch(
            AGGREGATE_SECTION_THUNKS[key].rejected(
              new Error(String(data?.errors?.[key] ?? "aggregate section missing")),
              rid,
              arg
            )
          );
        } else {
          dispatch(AGGREGATE_SECTION_THUNKS[key].fulfilled(section, rid, arg));
        }
      });
      return { keys: sections, sections: sections.length };
    } catch (error: any) {
      sections.forEach((key) =>
        dispatch(AGGREGATE_SECTION_THUNKS[key].rejected(error, rid, arg))
      );
      throw error;
    }
  }
);

export {
  getUserClients,
  getClientPrograms,
  getClientSalesRep,
  getBranchesDepartments,
  getLastUpdated,
  getDashboardAggregate,
  getGrowthScore,
  getRetention,
  getAtRisk,
  getGoogleReviews,
  getNpsScore,
  getNpsSurvey,
  getIndustries,
  getPurchase,
  getRetentionLeads,
  getProspectVerified,
  getEmailReports,
  getGrowthRate,
  getGrowthRateDetail,
  getGrowthRateBenchmark,
  getForecastDetail,
  getAtriskDetail,
  getWgs,
  getWgsDetail,
  getGgdRating,
  getGgdRatingDetail,
  getNetPromoter,
  getCustomerSurvey,
  getRetentionRate,
  getLastPurchaseCustomerLeads,
  getLastPurchaseDetail,
  getProspectLeadsReports,
  getProspectLeadsReportsDetail,
  getGainLostAccounts,
  getIndustryByRevenue,
  getIndustryByRevenueDetail,
  getPurchaseDistribution,
  getDistributionTransactionRevenue,
  getCustomerSurveyDetail,
  getProductAnalysisDetail,
  getRankByEmail,
  getRankByRetention,
  getRankByStableAccount,
  getRankByWgs,
  getRankByWgsDetails,
  getMarketByCustomer,
  getMarketOverview,
  getProductByCustomerCount,
  getProductByRevenue,
  getForecastRevenuePlan,
  getBranchTransaction,
  getTrainingCourse,
  getTrainingModuleSummary,
  getTrainingModule,
  getClientSalesmenMetrics,
  getBranchRankByStable,
  getBranchRankByEmail,
  getBranchRankByRetention,
  getAssociatedProduct,
  getTrainingUsers,
  getTrainingRoles,
  getTrainingSchools,
  getTrainingDomains,
  getTableSettings,
  saveTableSettings,
  deleteTableSettings
};
